import { DialogTrigger, Dialog, Modal } from 'react-aria-components';
import { SubmitHandler, useForm } from 'react-hook-form';

import { useAtom } from 'jotai';

import { updatePerformanceRecord } from '@/api/updatePerformanceRecord';
import Button from '@/components/Button/Button';
import { NotificationAtom } from '@/jotai/jotai';
import { PerformanceRecordRequest, PerformanceRecord } from '@/types/performanceRecord';

type Props = {
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  afterSubmit: () => void;
  performanceRecord: PerformanceRecord;
};

export const PublishDialog = ({ isOpen, setIsOpen, afterSubmit, performanceRecord }: Props) => {
  const [_, setNotification] = useAtom(NotificationAtom);

  const { handleSubmit } = useForm<PerformanceRecordRequest>({});

  const onSubmit: SubmitHandler<PerformanceRecordRequest> = async () => {
    try {
      const result = await updatePerformanceRecord(performanceRecord.id, {
        status: 'published',
      });
      console.log(result);
      if (result.status === 200) {
        console.log(result.result);
        setNotification({
          headingLevel: 'h2',
          type: 'success',
          bannerStyle: 'standard',
          title: '実績記録票を公開しました',
          message: '実績記録票を公開しました',
        });
      } else {
        setNotification({
          headingLevel: 'h2',
          type: 'error',
          bannerStyle: 'standard',
          title: '実績記録票の公開に失敗しました',
          message: '実績記録票の公開に失敗しました',
        });
      }
    } catch (error) {
      setNotification({
        headingLevel: 'h2',
        type: 'error',
        bannerStyle: 'standard',
        title: '実績記録票の公開に失敗しました',
        message: '実績記録票の公開に失敗しました',
      });
    }

    setIsOpen(false);
    afterSubmit();
  };

  return (
    <DialogTrigger
      isOpen={isOpen}
      onOpenChange={() => setIsOpen(false)}
    >
      <Modal className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
        <Dialog className="w-[600px] rounded-lg border border-gray-400 bg-white p-6 shadow-lg outline-none">
          <form onSubmit={handleSubmit(onSubmit)}>
            <div className="flex flex-row gap-4">
              <span>{`${performanceRecord.target_date.substring(0, 7)}の実績記録票を公開しますがよろしいですか？`}</span>
            </div>
            <div className="mt-10 flex flex-row items-center justify-center space-x-2">
              <Button
                type="button"
                size="lg"
                variant="outline"
                onClick={() => setIsOpen(false)}
              >
                戻る
              </Button>
              <Button
                variant="solid-fill"
                size="lg"
                type="submit"
              >
                公開
              </Button>
            </div>
          </form>
        </Dialog>
      </Modal>
    </DialogTrigger>
  );
};
